import React from 'react';

import { Menu, MenuItem, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

function DropdownMenuList({
    id,
    anchorEl,
    open,
    onClose,
    classes,
    menuTitle,
    options,
    value,
    showActiveState,
    renderOption,
    onSelect,
    closeMenu,
    children,
}) {
    return (
        <Menu
            id={id}
            className={classes.dropdownMenu}
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            disableEnforceFocus
        >
            {menuTitle && (
                <MenuItem className={classes.menuHeading} disabled disableRipple>
                    <Typography className={classes.menuHeadingText}>{menuTitle}</Typography>
                </MenuItem>
            )}
            {children
                ? children({ closeMenu, menuItemClass: classes.menuItem })
                : options.map((option) => (
                      <MenuItem
                          key={option.value}
                          className={clsx(
                              classes.menuItem,
                              option.className,
                              showActiveState && option.value === value && classes.menuItemActive
                          )}
                          onClick={() => onSelect(option)}
                      >
                          {renderOption ? renderOption(option) : option.label ?? option.value}
                      </MenuItem>
                  ))}
        </Menu>
    );
}

DropdownMenuList.propTypes = {
    id: PropTypes.string,
    anchorEl: PropTypes.any,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    classes: PropTypes.object,
    menuTitle: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.any,
    showActiveState: PropTypes.bool,
    renderOption: PropTypes.func,
    onSelect: PropTypes.func,
    closeMenu: PropTypes.func,
    children: PropTypes.func,
};

export default DropdownMenuList;
